// extracted by mini-css-extract-plugin
module.exports = {"uploadImageMain":"uploadImageLarge_uploadImageMain__20R4G","fileSelectedText":"uploadImageLarge_fileSelectedText__2IitB"};